import React from "react";
import TextBox from "../../TextBox";
import './style.css';

class Bubble extends React.Component {

    render() {
        let color = "#fff";
        if (this.props.customColor) {
            color = this.props.customColor;
        }
        const style = {
            boxShadow: `0px 0px 12px 5px inset ${color}`
        };
        return <div className="position-relative">
            <div className={`${this.props.isSpin === "true" || this.props.isSpin === true ? "fa-spin" : ""}`}>
                <div style={{
                    transformOrigin: `${this.props.transformOriginX ? this.props.transformOriginX : "center"} ${this.props.transformOriginY ? this.props.transformOriginY : "center"}`,
                    transform: `
                        ${this.props.scale ? `scale(${this.props.scale})` : ""}
                        ${this.props.flipX === "true" || this.props.flipX === true ? "scaleX(-1)" : ""}
                        ${this.props.rotate ? `rotate(${this.props.rotate}deg)` : ""}
                        `
                }}>
                    <div className={`Bubble-Bubble mx-auto position-relative mb-2 `} style={style}></div>
                </div>
            </div>
            <TextBox {...this.props} />
        </div>;
    }
}

export default Bubble;